module.exports = __webpack_public_path__ + "static/media/buy_question_1.362d3271.jpg";